import httpClient from 'shared/lib/httpClient';

export const deleteRole = async (id) => {
  const response = await httpClient.delete(`/company-roles/${id}`);
  return response?.data;
};
